// extracted by mini-css-extract-plugin
export default {"collapsibleContent":"CollapsibleSection_collapsibleContent__pEuon","collapsibleContentOpen":"CollapsibleSection_collapsibleContentOpen__QbeVa"};